var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrophone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 20.333c2.213 0 4-1.786 4-4v-8c0-2.213-1.787-4-4-4-2.214 0-4 1.787-4 4v8c0 2.214 1.786 4 4 4zm7.88-4c-.654 0-1.2.48-1.307 1.134C23.025 20.6 20.292 23 16.999 23c-3.294 0-6.027-2.4-6.574-5.533a1.33 1.33 0 00-1.306-1.134c-.814 0-1.454.72-1.334 1.52a9.323 9.323 0 007.88 7.707v2.773c0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334V25.56a9.323 9.323 0 007.88-7.707c.133-.8-.52-1.52-1.333-1.52z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microphone.7dabefb23a808302b15351292f8bc428.svg";